import SaveButton from "@/components/SaveButton";
import { Button } from "@/components/ui/button";
import { DialogClose, DialogFooter } from "@/components/ui/dialog";
import { memo } from "react";
import { useTranslation } from "react-i18next";

const ProjectSchedulesUpdateDialogFooterComponent = () => {
  const { t } = useTranslation();
  return (
    <DialogFooter>
      <DialogClose asChild>
        <Button variant="outline">{t("common.cancel")}</Button>
      </DialogClose>
      <SaveButton />
    </DialogFooter>
  );
};

export const ProjectSchedulesUpdateDialogFooter = memo(
  ProjectSchedulesUpdateDialogFooterComponent,
);
